import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DISPATCH_ID, SERVICE_RESPONSE, decodeText } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import moment from "moment";
import $ from "jquery";
import {
    NavBar,
    BreadCumb,
    TimeOut,
    SucursalModal,
    ListModal,
    ValidationModal
} from '../../components';
import {
    Employee,
    Sucursal,
    AdministratorUsers,
    BankAccountRelationship
} from '../../components/NewOrder';

let apiClient = ApiClient.getInstance();
const EMAIL_FORMAT_REGEX = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

class SucursalView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null,
            data: [],
            total: 0,
            sucursales: [],
            showEmployee: false,
            employeeModalAction: "",
            editMode: false,
            employeeModel: {},
            typeVisibility: true,
            dataEmployee: [],
            showChangePasswordModal: false,
            typeVisibilityOld: true,
            typeVisibilitynew: true,
            typeVisibilityconfirm: true,
            showSucursal: false,
            sucursalModalAction: "",
            sucursalModel: {},
            sucursalModelCopy: new Sucursal(),
            showSearchSucursalModal: false,
            editModeSucursal: false,
            priceList: [],
            whsCode: [],
            partners: [],
            pageTotal: 0,
            showSearchEmployeeModal: false,
            employees: [],
            series: [],
            projects: [],
            paymentMethods: [],
            //------------------
            PayMethodModel: {
                code: '',
                name: '',
                type: '',
                idCard: ''
            },
            checkboxPayMethods: (new Map()),
            checkboxDocSeries: (new Map()),
            // showWhsModal: false
            adminUsersModel: new AdministratorUsers(),
            showSeriesModal: false,
            property: '',
            // add new to affect the account
            addNewAccount: false,
            accounts: [],
            SAPCards: [],
            relationModel: new BankAccountRelationship(),
            accountsRelated: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            searchedConsecutiveInfo: false,
            auxObjectUpgradeLoopDoc: null,

            //series and consecutive
            documentTypeSeries: [],
            propertyCode: null,
            search: ''

        }
        this.employeeModals = null;
    }

    componentDidMount = async () => {
        const { enableSpinner } = this.props;
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liSucursales");
        enableSpinner(true);
        let listsucursales = await apiClient.getSucursales();
        let info = await apiClient.getDataEmployee();
        let pricelist = await apiClient.getPriceList();
        let whscode = await apiClient.getWhsCodes();
        let avalibleProjects = await apiClient.getProjectsList();
        let paymentmethodsres = await apiClient.getPaymentMethods();
        // cuentas de mayor
        await this.GetDestinationAccounts();
        await this.GetCreditCards();
        // SERIES
        let dataSerie = {
            docType: '',
            docSubType: ''
        };
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);
        // SERIES
        this.setState({
            sucursales: listsucursales.data || [],
            dataEmployee: info.data || [],
            priceList: pricelist.data || [],
            whsCode: whscode.data || [],
            series: seriesResponse.data || [],
            projects: avalibleProjects.data || [],
            paymentMethods: paymentmethodsres.data || [],
        })
        this.OpenSucursal();

        // Detectar combinaciones de teclas
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = async (event) => {
        // Entrar al modo de edición
        if (event.altKey && event.ctrlKey && event.key.toLowerCase() === "e") {
            const { user, sucursalModalAction } = this.state;
            const modules = user.U_FMB_Modulos ? JSON.parse(user.U_FMB_Modulos) : null
            const writeAccess = modules?.sucursales?.Wr ?? false;

            if (writeAccess && sucursalModalAction === 2) {
                this.setState({ editModeSucursal: true });
            }
        }

    }

    GetDestinationAccounts = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.getCuentaMayor();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return
        }
        this.setState({ accounts: responseApi.data || [] })
    }

    GetCreditCards = async () => {
        let responseApi = await apiClient.getCards();
        this.setState({
            SAPCards: responseApi.data || [],
        })
    }

    AcceptEditMode = () => {
        this.setState({
            editMode: !this.state.editMode,
        });
    };

    SearchEmployee = async filter => {
        const { notificationReducer: { showAlert } } = this.props;
        await this.setState({
            showSearchEmployeeModal: !this.state.showSearchEmployeeModal,
        });
        let employeeResponse = await apiClient.getEmployee();

        if (employeeResponse.status === SERVICE_RESPONSE.SUCCESS) {
            await this.setState({
                employees: employeeResponse.data.employee,
            });
        } else {
            showAlert({ type: 'error', message: employeeResponse.message });
        }
    };

    SearchOneEmployee = async (empID) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let index = 1;
        enableSpinner(true);
        // let employeeResponse = await apiClient.getEmployee(filter);

        if (empID) {
            let open = {
                Employee: empID || 1,
                index
            };
            this.OpenEmployeeDetails(open);
            $('#searchEmployeeModal').modal('hide');
            await this.setState({
                showSearchEmployeeModal: false,
            });
        } else {
            showAlert({ type: 'warning', message: 'No se encontró ningun registro', timeOut: 5000 });
        }
        enableSpinner(false);
    };

    ShowEmployeeModal = async () => {
        await this.setState({
            showEmployee: !this.state.showEmployee
        });
    }

    //#region EMPLOYEE
    EyeVisibility = async () => {
        this.setState({
            typeVisibility: !this.state.typeVisibility
        })
    };

    OpenEmployee = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { user } = this.state;
        if (!user || user.FMB_Role !== 'admin1') {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }

        enableSpinner(true);

        let modelEmployee = new Employee();

        await this.setState({
            employeeModel: modelEmployee,
            employeeModalAction: 1,
            showEmployee: !this.state.showEmployee, // show
        });

        enableSpinner(false);
    };

    OpenEmployeeDetails = async (open, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);

        let employeeResponse = await apiClient.getEmployeeDetails(open.Employee);

        if (employeeResponse.status === SERVICE_RESPONSE.SUCCESS) {

            let newOrderModel = await this.fillsEmployeeDetailsModel(employeeResponse, open);

            this.setState({
                employeeModel: newOrderModel,
                newEmployeeMode: { employeeResponse, open },
                employeeModalAction: 2, // show
                editMode: edit === 1 ? true : false,
            });

            enableSpinner(false);
            this.employeeModals.setState({
                editMode: false
            });
            return;
        }
        enableSpinner(false);
        showAlert({ type: 'error', message: employeeResponse.message });
    };

    fillsEmployeeDetailsModel = async (model, open) => {
        let employeeModel = new Employee();
        let employee = model.data.employee;

        employeeModel.update = 1;

        employeeModel.EmployeeID = employee.empID || '';
        employeeModel.SalesEmployeeCode = employee.salesPrson || '';
        employeeModel.FirstName = employee.firstName || '';
        employeeModel.LastName = employee.lastName || '';
        employeeModel.eMail = employee.email || '';
        employeeModel.Active = employee.Active || '';
        employeeModel.Role = employee.Role || '';
        employeeModel.Password = employee.Password || '';
        employeeModel.Sucursal = employee.Sucursal || '';
        employeeModel.CardCode = employee.CardCode || '';
        employeeModel.Caja = employee.Caja || '';
        employeeModel.Gender = employee.sex || '';
        employeeModel.DateOfBirth = moment(employee.birthDate || '').utc().format('YYYY-MM-DD');
        employeeModel.MobilePhone = employee.mobile || '';

        employeeModel.U_FMB_passwd = employee.U_FMB_passwd || '';
        employeeModel.OldPassword = employee.OldPassword || '';
        employeeModel.PasswordDecrypt = employee.PasswordDecrypt || '';
        employeeModel.U_FMB_passwdNew = employee.U_FMB_passwdNew || '';
        employeeModel.U_FMB_passwdConfirm = employee.U_FMB_passwdConfirm || '';

        // direccion de trabajo
        employeeModel.WorkStreet = employee.workStreet || '';
        employeeModel.WorkStreetNumber = employee.StreetNoW || '';
        employeeModel.WorkBlock = employee.workBlock || '';
        employeeModel.WorkBuildingFloorRoom = employee.WorkBuild || '';
        employeeModel.WorkZipCode = employee.workZip || '';
        employeeModel.WorkCity = employee.workCity || '';
        employeeModel.WorkCounty = employee.workCounty || '';
        employeeModel.WorkStateCode = employee.workState || '';
        employeeModel.WorkCountryCode = employee.workCountr || '';
        // direccion de casa        
        employeeModel.HomeStreet = employee.homeStreet || '';
        employeeModel.HomeStreetNumber = employee.StreetNoH || '';
        employeeModel.HomeBlock = employee.homeBlock || '';
        employeeModel.HomeBuildingFloorRoom = employee.HomeBuild || '';
        employeeModel.HomeZipCode = employee.homeZip || '';
        employeeModel.HomeCity = employee.homeCity || '';
        employeeModel.HomeCounty = employee.homeCounty || '';
        employeeModel.HomeState = employee.homeState || '';
        employeeModel.HomeCountry = employee.homeCountr || '';

        return employeeModel;
    };

    AcceptEditModeEmployee = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newEmployeeMode } = this.state;
        if (model.FirstName === '') {
            showAlert({ type: 'warning', message: "Aviso: El nombre no puede ir vacío" })
            this.ValidateFirstName();

            return;
        }
        if (model.LastName === '') {
            showAlert({ type: 'warning', message: "Aviso: El apellido no puede ir vacío" })
            return;
        }
        if (model.eMail === '') {
            showAlert({ type: 'warning', message: "Aviso: El correo no puede ir vacío" })
            return;
        }
        if (!EMAIL_FORMAT_REGEX.test(model.eMail)) return showAlert({
            type: 'warning',
            message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'
        });
        if (model.Role === '' || model.Role === '---') {
            showAlert({ type: 'warning', message: "Aviso: El tipo de usuario no puede ir vacío" })
            return;
        }
        if (model.U_FMB_Sucursal === '' || model.U_FMB_Sucursal === '---') {
            showAlert({ type: 'warning', message: "Aviso: Escoge algúna sucursal" })
            return;
        }
        if (model.CardCode === '' || model.CardCode === '---') {
            showAlert({ type: 'warning', message: "Aviso: Escoge algún cliente" })
            return;
        }
        if (model.U_FMB_Caja === '' || model.U_FMB_Caja === '---') {
            showAlert({ type: 'warning', message: "Aviso: Escoge algúna caja" })
            return;
        }

        let data = {
            model: model,
        };

        enableSpinner(true);

        let response = await apiClient.updateEmployee(data);

        enableSpinner(false);

        if (response.status === 1) {
            await this.OpenEmployeeDetails(newEmployeeMode.open, true);
            showAlert({ type: 'success', message: response.message });
            this.employeeModals.setState({
                editMode: false
            })
            $('#employeeModal').modal('hide');
        } else {
            showAlert({ type: 'error', message: response.message });
            await this.setState({
                employeeModel: model
            })
        }
    };

    SendEmployeeModel = async employeeModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        if (employeeModel.FirstName === '') {
            // showAlert({ type: 'warning', message: "Aviso: El nombre no puede ir vacío" })
            return;
        }
        if (employeeModel.LastName === '') {
            // showAlert({ type: 'warning', message: "Aviso: El apellido no puede ir vacío" })
            return;
        }
        if (employeeModel.eMail === '') {
            // showAlert({ type: 'warning', message: "Aviso: El correo no puede ir vacío" })
            return;
        }
        if (!EMAIL_FORMAT_REGEX.test(employeeModel.eMail)) return
        // showAlert({type: 'warning',message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'});
        if (employeeModel.Role === '' || employeeModel.Role === '---') {
            // showAlert({ type: 'warning', message: "Aviso: El tipo de usuario no puede ir vacío" })
            return;
        }
        if (employeeModel.U_FMB_passwd === '') {
            // showAlert({ type: 'warning', message: "Aviso: La contraseña no puede ir vacía" })
            return;
        }
        if (employeeModel.U_FMB_Sucursal === '' || employeeModel.U_FMB_Sucursal === '---') {
            showAlert({ type: 'warning', message: "Aviso: Escoge algúna sucursal" })
            return;
        }
        if (employeeModel.CardCode === '' || employeeModel.CardCode === '---') {
            showAlert({ type: 'warning', message: "Aviso: Escoge algún cliente" })
            return;
        }
        if (employeeModel.U_FMB_Caja === '' || employeeModel.U_FMB_Caja === '---') {
            showAlert({ type: 'warning', message: "Aviso: Escoge algúna caja" })
            return;
        }

        enableSpinner(true);
        let data = {
            model: employeeModel,
        };

        let response = await apiClient.createEmployee(data);

        enableSpinner(false);

        if (response.status === 1) {
            showAlert({ type: 'success', message: response.message });
            setTimeout(() => {
                $('#employeeModal').modal('hide');
            }, 100);
        } else {
            await this.setState({
                employeeModel
            })
        }
    };

    RefreshEmployeeModel = employeeModel => {
        this.setState({
            employeeModel
        })
    };

    CancelEditModeEmployee = async () => {
        const { newEmployeeMode } = this.state;

        let newOrderResponse = await this.fillsEmployeeDetailsModel(newEmployeeMode.employeeResponse, newEmployeeMode.open);

        this.setState({
            employeeModel: newOrderResponse,
            editMode: false,
        });
    };

    ChangePasswordEmployee = async employeeModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newEmployeeMode } = this.state;

        if (employeeModel.OldPassword === '') {
            showAlert({ type: 'warning', message: 'Por favor escriba su contraseña actual' })
            return;
        }

        if (employeeModel.OldPassword !== employeeModel.PasswordDecrypt) {
            showAlert({ type: 'error', message: 'Aviso: La contraseña actual es incorrecta' })
            return;
        }

        if (employeeModel.U_FMB_passwdNew === '') {
            showAlert({ type: 'warning', message: 'Aviso: Escribe una contraseña nueva' })
            return;
        }

        if (employeeModel.U_FMB_passwdConfirm === '') {
            showAlert({ type: 'warning', message: 'Aviso: Vuelve a escribir tu nueva contraseña' })
            return;
        }

        if (employeeModel.U_FMB_passwdNew !== employeeModel.U_FMB_passwdConfirm) {
            showAlert({ type: 'error', message: 'Aviso: Las contraseñas no coinciden' })
            return;
        }

        if (employeeModel.U_FMB_passwdNew === employeeModel.U_FMB_passwdConfirm && employeeModel.OldPassword === employeeModel.PasswordDecrypt) {

            let data = {
                code: employeeModel.EmployeeID,
                password: employeeModel.U_FMB_passwdNew
            }

            enableSpinner(true);
            let response = await apiClient.updatePassEmployee(data);
            enableSpinner(false);

            if (response.status === 1) {
                await this.OpenEmployeeDetails(newEmployeeMode.open, 1);
                showAlert({ type: 'success', message: response.message });
                $('#changePasswordModal').modal('hide');
                this.setState({
                    showChangePasswordModal: false,
                })
            }
        }
    };

    DeleteEmployee = async employeeModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        let data = {
            code: employeeModel.EmployeeID,
        }

        enableSpinner(true);
        let response = await apiClient.deleteEmployee(data);
        enableSpinner(false);

        if (response.status === 1) {
            showAlert({ type: 'success', message: response.message });
            $('#employeeModal').modal('hide');
        }
    };

    OpenChangePasswordModal = async () => {
        await this.setState({
            showChangePasswordModal: !this.state.showChangePasswordModal,
            typeVisibilityOld: true,
            typeVisibilitynew: true,
            typeVisibilityconfirm: true,
        });
    };

    EyeVisibilityOld = async () => {
        const { typeVisibilityOld } = this.state;
        this.setState({
            typeVisibilityOld: !typeVisibilityOld
        })
    };

    EyeVisibilityNew = async () => {
        const { typeVisibilitynew } = this.state;
        this.setState({
            typeVisibilitynew: !typeVisibilitynew
        })
    };

    EyeVisibilityConfirm = async () => {
        const { typeVisibilityconfirm } = this.state;
        this.setState({
            typeVisibilityconfirm: !typeVisibilityconfirm
        })
    };

    CloseChangePasswordModal = async () => {
        $('#changePasswordModal').modal('hide');

        await this.setState({
            showChangePasswordModal: !this.state.showChangePasswordModal,
        });
    };
    //#endregion EMPLOYEE

    RefreshSucursalModel = sucursalModel => {
        this.setState({
            sucursalModel
        })
    };

    RefreshPayMethodModel = PayMethodModel => {
        this.setState({
            PayMethodModel
        })
    };

    SearchSucursal = async filter => {
        await this.callSucursales(filter);
    };

    CloseSearchSucursalModal = async () => {
        $('#searchSucursalModal').modal('hide');

        await this.setState({
            showSearchSucursalModal: !this.state.showSearchSucursalModal,
        });
    };

    callSucursales = async (id) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const sucursalResponse = await apiClient.getOneSucursal(id);
        if (sucursalResponse.status === 1) {
            const responseModel = await this.FillsSucursalModel(sucursalResponse);
            $('#searchSucursalModal').modal('hide');
            this.setState({
                sucursalModel: responseModel,
                sucursalModelCopy: responseModel,
                sucursalModalAction: 2, // show
                editModeSucursal: false,
                showSearchSucursalModal: false,
            });

        } else {
            showAlert({ type: 'warning', message: 'No se encontró ninguna sucursal', timeOut: 5000 });
        }
        enableSpinner(false);
    };

    EditModeSucursal = () => {
        this.setState({
            editModeSucursal: !this.state.editModeSucursal,
        });
    };

    SendSucursalModel = async sucursalModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { checkboxPayMethods, paymentMethods } = this.state

        if (sucursalModel.Nombre === '') {
            showAlert({ type: 'warning', message: "Aviso: El nombre no puede ir vacío" })
            return;
        }
        if (sucursalModel.Code === '') {
            showAlert({ type: 'warning', message: "Aviso: El código no puede ir vacío" })
            return;
        }
        if (sucursalModel.Direccion === '') {
            showAlert({ type: 'warning', message: "Aviso: La dirección no puede ir vacía" })
            return;
        }
        if (sucursalModel.Cp === '') {
            showAlert({ type: 'warning', message: "Aviso: El código postal no puede ir vacío" })
            return;
        }
        if (sucursalModel.Telefono === '') {
            showAlert({ type: 'warning', message: "Aviso: El teléfono no puede ir vacío" })
            return;
        }
        if (sucursalModel.ListPartners.length === 0) {
            showAlert({ type: 'warning', message: "Aviso: Selecciona algún cliente" })
            return;
        }
        if (sucursalModel.Project === '' || sucursalModel.Project === '---') {
            showAlert({ type: 'warning', message: "Aviso: El campo de Almacén no puede ir vacío" })
            return;
        }
        if (sucursalModel.Code.length !== 3) {
            showAlert({ type: 'warning', message: "Aviso: El código debe de ser 3 caracteres alfanuméricos" })
            return;
        }
        if (sucursalModel.ListPayMethods.length === 0) {
            showAlert({ type: 'warning', message: "Aviso: Agrega métodos de pago para la sucursal" })
            return;
        }
        if (sucursalModel.isBorder === '' || sucursalModel.isBorder === '---') {
            showAlert({ type: 'warning', message: "Aviso: El campo de frontera no puede ir vacío" })
            return;
        }
        if (sucursalModel.TimeZone === '' || sucursalModel.TimeZone === '---') {
            showAlert({ type: 'warning', message: "Aviso: Aun no has seleccionado la zona horaria" })
            return;
        }

        if (sucursalModel.manager_Email === '' || sucursalModel.manager_Email === '---') {
            showAlert({ type: 'warning', message: "Aviso: Aun no has llenado el campo correo representante" })
            return;
        }

        enableSpinner(true);
        let data = {
            model: sucursalModel,
        };
        let response = await apiClient.createSucursal(data);
        enableSpinner(false);

        if (response.status === 1) {
            showAlert({ type: 'success', message: response.message });

            let listSucursales = await apiClient.getSucursales();
            await this.setState({
                showSucursal: false,
                sucursales: listSucursales.data,
                sucursalModel: new Sucursal(),
                checkboxPayMethods: (new Map()),
            })
        } else {
            if (response.status === 2) showAlert({ type: 'info', message: response.message });
            await this.setState({
                sucursalModel
            })
        }
    };

    OpenSearchSucursalModal = async () => {
        await this.setState({
            showSearchSucursalModal: !this.state.showSearchSucursalModal,
        });
    };

    OpenSucursal = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { user } = this.state;

        if (!user || user.FMB_Role !== 'admin1') {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }

        enableSpinner(true);
        let modelsucursal = new Sucursal();
        await this.setState({
            sucursalModel: modelsucursal,
            sucursalModalAction: 1,
            // showSucursal: !this.state.showSucursal, // show
        });
        enableSpinner(false);
    };

    FillsSucursalModel = async (model) => {
        const { accounts } = this.state;
        let sucursalModel = new Sucursal();
        let sucursal = model.data[0];


        sucursalModel.update = 1;
        sucursalModel.ID = sucursal.pk_Sucursal || '';
        sucursalModel.Nombre = sucursal.nombre || '';
        sucursalModel.Code = sucursal.code || '';
        sucursalModel.Direccion = sucursal.direccion || '';
        sucursalModel.Cp = sucursal.cp || '';
        sucursalModel.Telefono = sucursal.telefono || '';
        sucursalModel.Clientes = sucursal.clientes || '';
        sucursalModel.ListPartners = sucursal.ListPartners || [];
        sucursalModel.Project = sucursal.project || '';
        sucursalModel.ListWhs = sucursal.ListWhs || [];
        //isBorder
        sucursalModel.isBorder = sucursal.isBorder || '';
        sucursalModel.TimeZone = sucursal.timeZone || '';

        //---PRICES LIST BY MODULE----
        sucursalModel.U_FMB_DEF_PLInventoryGenExitService = sucursal.U_FMB_DEF_PLInventoryGenExitService;
        sucursalModel.U_FMB_DEF_PLInventoryGenEntryService = sucursal.U_FMB_DEF_PLInventoryGenEntryService;
        sucursalModel.U_FMB_PLPrintTags = sucursal.U_FMB_PLPrintTags;

        sucursalModel.U_FMB_DEF_PLStockTransfer = sucursal.U_FMB_DEF_PLStockTransfer;
        sucursalModel.U_FMB_DEF_PLReqStockTransfer = sucursal.U_FMB_DEF_PLReqStockTransfer;
        //---SERIES FOR DOCS
        sucursalModel.U_FMB_ValidateSeriesOINV = sucursal.U_FMB_ValidateSeriesOINV;
        sucursalModel.U_FMB_ValidateSeriesORDR = sucursal.U_FMB_ValidateSeriesORDR;
        sucursalModel.U_FMB_ValidateSeriesODLN = sucursal.U_FMB_ValidateSeriesODLN;
        sucursalModel.U_FMB_ValidateSeriesORDN = sucursal.U_FMB_ValidateSeriesORDN;
        sucursalModel.U_FMB_ValidateSeriesORCT = sucursal.U_FMB_ValidateSeriesORCT;
        sucursalModel.U_FMB_ValidateSeriesOWTR = sucursal.U_FMB_ValidateSeriesOWTR;
        sucursalModel.U_FMB_ValidateSeriesDN = sucursal.U_FMB_ValidateSeriesDN;
        sucursalModel.U_FMB_ValidateSeriesORIN = sucursal.U_FMB_ValidateSeriesORIN;
        sucursalModel.U_FMB_ValidateSeriesOWTQ = sucursal.U_FMB_ValidateSeriesOWTQ;
        sucursalModel.U_FMB_ValidateSeriesOIGN = sucursal.U_FMB_ValidateSeriesOIGN;
        sucursalModel.U_FMB_ValidateSeriesOIGE = sucursal.U_FMB_ValidateSeriesOIGE;
        sucursalModel.U_FMB_ValidateSeriesOPOR = sucursal.U_FMB_ValidateSeriesOPOR;
        sucursalModel.U_FMB_ValidateSeriesOPRQ = sucursal.U_FMB_ValidateSeriesOPRQ;
        sucursalModel.U_FMB_ValidateSeriesORPD = sucursal.U_FMB_ValidateSeriesORPD;
        sucursalModel.U_FMB_ValidateSeriesOMRV = sucursal.U_FMB_ValidateSeriesOMRV;
        sucursalModel.U_FMB_ValidateSeriesOPDN = sucursal.U_FMB_ValidateSeriesOPDN;
        sucursalModel.U_FMB_ValidateSeriesOVPM = sucursal.U_FMB_ValidateSeriesOVPM;
        sucursalModel.U_FMB_ValidateSeriesOPCH = sucursal.U_FMB_ValidateSeriesOPCH;
        sucursalModel.U_FMB_ValidateSeriesORPC = sucursal.U_FMB_ValidateSeriesORPC;
        sucursalModel.U_FMB_ValidateSeriesDM = sucursal.U_FMB_ValidateSeriesDM;
        sucursalModel.U_FMB_ValidateSeriesOQUT = sucursal.U_FMB_ValidateSeriesOQUT;
        sucursalModel.U_FMB_ValidateSeriesODPI = sucursal.U_FMB_ValidateSeriesODPI;
        sucursalModel.U_FMB_ValidateSeriesOWOR = sucursal.U_FMB_ValidateSeriesOWOR;
        sucursalModel.U_FMB_ValidateSeriesOINC = sucursal.U_FMB_ValidateSeriesOINC;
        sucursalModel.U_FMB_ValidateSeriesOIQR = sucursal.U_FMB_ValidateSeriesOIQR;
        sucursalModel.U_FMB_ValidateSeriesOPQT = sucursal.U_FMB_ValidateSeriesOPQT;

        sucursalModel.U_FMB_ValidateSeriesOIPF = sucursal.U_FMB_ValidateSeriesOIPF;
        sucursalModel.U_FMB_SeriesInventoryGenExits = sucursal.U_FMB_SeriesInventoryGenExits;
        sucursalModel.U_FMB_SeriesInventoryGenEntries = sucursal.U_FMB_SeriesInventoryGenEntries;
        sucursalModel.U_FMB_SeriesSugerido = sucursal.U_FMB_SeriesSugerido;
        sucursalModel.U_FMB_ValidateSeriesODPO = sucursal.U_FMB_ValidateSeriesODPO;

        sucursalModel.LimitLines = sucursal.LimitLines;
        sucursalModel.U_FMB_DEF_PLPriceMin = sucursal.U_FMB_DEF_PLPriceMin;
        sucursalModel.U_FMB_DEF_PLBasePrice = sucursal.U_FMB_DEF_PLBasePrice;
        sucursalModel.manager_Email = sucursal?.manager_Email ?? '';

        sucursalModel.ActCodeCN = sucursal?.ActCodeCN ?? '';
        sucursalModel.ActNameCN = accounts.find(({ AcctCode }) => AcctCode === sucursalModel.ActCodeCN)?.AcctName ?? '';

        sucursalModel.ActCodeRT = sucursal?.ActCodeRT ?? '';
        sucursalModel.ActNameRT = accounts.find(({ AcctCode }) => AcctCode === sucursalModel.ActCodeRT)?.AcctName ?? '';

        // await this.FillPaymentCheckList(sucursal.PayMethods || []);
        // sucursalModel.ListPayMethods = sucursal.PayMethods || [];
        sucursalModel.ListPayMethods = await this.FillBankAccountsModel(sucursal.PayMethods);
        sucursalModel.Type = sucursal?.Type ?? '';

        //SERIES AND CONSECUTIVES
        let currSeries = sucursal?.U_FMB_ValidateSeriesSUNAT;
        try {
            sucursalModel.U_FMB_ValidateSeriesSUNAT = JSON.parse(currSeries && currSeries.trim() !== "" ? currSeries : "{}");
        } catch (e) {
            sucursalModel.U_FMB_ValidateSeriesSUNAT = {};
        }
        let seriesPUERTA = sucursal?.U_FMB_ValidateSeriesPUERTA;
        try {
            sucursalModel.U_FMB_ValidateSeriesPUERTA = JSON.parse(seriesPUERTA && seriesPUERTA.trim() !== "" ? seriesPUERTA : "{}");
        } catch (e) {
            sucursalModel.U_FMB_ValidateSeriesPUERTA = {};
        }

        return sucursalModel;
    };

    FillBankAccountsModel = async (responsePayMethods) => {

        let newArray = [];
        for (const payMethod of responsePayMethods) {
            let bankRelation = new BankAccountRelationship();
            bankRelation.idAPMBO = payMethod.idAPMBO;
            bankRelation.idPMBO = payMethod.idPMBO;
            bankRelation.pk_Sucursal = payMethod.pk_Sucursal;
            bankRelation.AcctCode = payMethod.AcctCode;
            bankRelation.AcctName = payMethod.AcctName;
            bankRelation.codePayMethod = payMethod.code;
            bankRelation.namePayMethod = payMethod.name;
            bankRelation.TipoUso = payMethod.TipoUso;
            newArray.push(bankRelation);
        }

        return newArray

    }

    SelectPartner = async action => {
        const { partners, sucursalModel } = this.state;
        let partner = partners[action.index];
        sucursalModel.ListPartners.push(partner);
        sucursalModel.ListPartners = [...new Set(sucursalModel.ListPartners)];
        this.RefreshSucursalModel(sucursalModel);
    }

    OpenPartnerModal = async () => {
        let getPartnerResponse = await apiClient.getPartner('C', null);

        await this.setState({
            partners: getPartnerResponse.data.results,
            pageTotal: getPartnerResponse.data.totalPage,
        });

        $('#partnerCreate').modal('show');
    };

    RefreshPartner = async (partner, totalPage) => {
        this.setState({
            partners: partner,
            pageTotal: totalPage
        });
    }

    AcceptEditModeSucursal = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        if (model.Nombre === '') {
            showAlert({ type: 'warning', message: "Aviso: El nombre no puede ir vacío" })
            return;
        }
        if (model.Code === '') {
            showAlert({ type: 'warning', message: "Aviso: El código no puede ir vacío" })
            return;
        }
        if (model.Direccion === '') {
            showAlert({ type: 'warning', message: "Aviso: La dirección no puede ir vacía" })
            return;
        }
        if (model.Cp === '') {
            showAlert({ type: 'warning', message: "Aviso: El código postal no puede ir vacío" })
            return;
        }
        if (model.Telefono === '') {
            showAlert({ type: 'warning', message: "Aviso: El teléfono no puede ir vacío" })
            return;
        }
        if (model.ListPartners.length === 0) {
            showAlert({ type: 'warning', message: "Aviso: Selecciona algún cliente" })
            return;
        }
        if (model.Project === '' || model.Project === '---') {
            showAlert({ type: 'warning', message: "Aviso: El campo de Almacén no puede ir vacío" })
            return;
        }
        if (model.Project === '' || model.Project === '---') {
            showAlert({ type: 'warning', message: "Aviso: El campo de Almacén no puede ir vacío" })
            return;
        }
        if (model.Code.length !== 3) {
            showAlert({ type: 'warning', message: "Aviso: El código debe de ser 3 caracteres alfanuméricos" })
            return;
        }
        if (model.ListPayMethods.length === 0) {
            showAlert({ type: 'warning', message: "Aviso: Agrega métodos de pago para la sucursal" })
            return;
        }
        if (model.isBorder === '' || model.isBorder === '---') {
            showAlert({ type: 'warning', message: "Aviso: El campo de frontera no puede ir vacío" })
            return
        }
        if (model.TimeZone === '' || model.TimeZone === '---') {
            showAlert({ type: 'warning', message: "Aviso: Aun no has seleccionado la zona horaria" })
            return;
        }
        if (model.manager_Email === '' || model.manager_Email === '---') {
            showAlert({ type: 'warning', message: "Aviso: Aun no has llenado el campo correo representante" })
            return;
        }

        // for (let [id, value] of checkboxPayMethods.entries()) {
        //     if (value) {
        //         model.ListPayMethods.push(paymentMethods[id]);
        //     }
        // }
        let data = {
            model: model,
        }

        enableSpinner(true);

        let response = await apiClient.updateSucural(data);

        enableSpinner(false);

        if (response.status === 1) {
            showAlert({ type: 'success', message: response.message });
            $('#sucursalModal').modal('hide');
            let listsucursales = await apiClient.getSucursales();
            this.setState({
                showSucursal: false,
                editModeSucursal: false,
                sucursales: listsucursales.data,
            })
        } else {
            showAlert({ type: response.status === 2 ? 'info' : 'error', message: response.message });
            await this.setState({
                sucursalModel: model
            })
        }
    };

    DeletePartner = async (indexToDelete) => {
        const { sucursalModel } = this.state;
        let newPartners = [];

        for (let index = 0; index < sucursalModel.ListPartners.length; index++) {
            const element = sucursalModel.ListPartners[index];
            if (indexToDelete !== index) {
                newPartners.push(element);
            }
        }
        sucursalModel.ListPartners = newPartners;
        this.RefreshSucursalModel(sucursalModel);
    };

    CancelEditModeSucursal = async () => {
        this.setState({
            editModeSucursal: !this.state.editModeSucursal,
            checkboxDocSeries: (new Map()),
        });
    };

    CloseSearchEmployeeModal = async () => {
        $('#searchEmployeeModal').modal('hide');
        await this.setState({
            showSearchEmployeeModal: !this.state.showSearchEmployeeModal,
        });
    };

    CleanInfo = () => {
        this.EditModeSucursal();
        this.setState({
            sucursalModel: new Sucursal(),
            sucursalModalAction: 1,
            checkboxPayMethods: (new Map()),
            checkboxDocSeries: (new Map()),
            searchedConsecutiveInfo: false

        })
    }

    //------ WWAREHOUSES NEW IMPLEMENTATIONS----
    CloseActionsWhs = () => {
    }

    ShowWhsModal = async (boolValue) => {
        if (boolValue) {
            $('#generalListModal').modal('show');
        } else {
            $('#generalListModal').modal('hide');
        }
    }

    AddWhsLine = async (index) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { sucursalModel, whsCode } = this.state
        let newSucursalModel = sucursalModel;
        let exitsWhsCode = newSucursalModel.ListWhs.find((whs) => Number(whs.WhsCode) === Number(whsCode[index].WhsCode));

        if (!exitsWhsCode) {
            // if (newSucursalModel.ListWhs.length > 0) {
            //     return showAlert({ type: 'warning', message: 'No se puede seleccionar más de un almacén por sucursal.' });
            // }

            newSucursalModel.ListWhs.push(whsCode[index]);
        } else {
            showAlert({ type: 'info', message: 'Ya cuenta con ese almacén seleccionado.' });
        }
        this.setState({ sucursalModel: newSucursalModel })
    }

    DeleteWhsLine = async (index) => {
        const { sucursalModel } = this.state
        sucursalModel.ListWhs.splice(index, 1); // 1 es la cantidad de elementos a eliminar
        this.setState({ sucursalModel })
    }

    SendPayMethodModel = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { PayMethodModel } = this.state
        if (PayMethodModel.code === '') {
            showAlert({ type: 'warning', message: "Aviso: El código no puede ir vacío" })
            return;
        }
        if (PayMethodModel.name === '') {
            showAlert({ type: 'warning', message: "Aviso: El nombre no puede ir vacío" })
            return;
        }
        if (PayMethodModel.type === '') {
            showAlert({ type: 'warning', message: "Aviso: El tipo de pago no puede ir vacío" })
            return;
        }
        if (Number(PayMethodModel.type) === 2 && PayMethodModel.idCard === '') {
            showAlert({ type: 'warning', message: "Aviso: No has seleccionado una tarjeta SAP" })
            return;
        }
        let data = {
            PayMethodModel
        }
        enableSpinner(true);
        const resInsertPayModel = await apiClient.createPayMethod(data);
        enableSpinner(false);
        if (resInsertPayModel.status !== 1) {
            showAlert({ type: 'error', message: `${resInsertPayModel.message ?? ''}` })
            return;
        }
        showAlert({ type: 'success', message: `${resInsertPayModel.message}` });
        let responseApi = await apiClient.getPaymentMethods();
        this.setState({
            PayMethodModel: {
                code: '',
                name: '',
                type: ''
            },
            paymentMethods: responseApi.data || []
        });
        await this.AddPayMethod(false);

    }
    selectAll = async (value) => {
        const { sucursalModel } = this.state
        await this.setState(state => {
            let newSeries = [...sucursalModel.newSeries];

            newSeries = newSeries.map((item, index) => ({
                ...item,
                selected: value
            }));
            sucursalModel.newSeries = newSeries;
            this.RefreshSucursalModel(sucursalModel);
        });
    }
    toggleDocumentSelected = async (id, option) => {
        const { sucursalModel } = this.state
        switch (option) {
            case 1:
                await this.setState(state => {
                    const checkboxPayMethods = new Map(state.checkboxPayMethods);
                    checkboxPayMethods.set(id, !checkboxPayMethods.get(id));
                    return { checkboxPayMethods };
                });
                break;
            case 2:
                await this.setState(state => {
                    let newSeries = sucursalModel.newSeries;
                    newSeries[id].selected = !newSeries[id].selected;
                    this.RefreshSucursalModel(sucursalModel);
                });
                break;
            case 3:
                await this.setState(state => {
                    let newSeries = [...sucursalModel.newSeries];

                    newSeries = newSeries.map((item, index) => ({
                        ...item,
                        default: index === id,
                        selected: index === id ? true : (item?.selected ?? false)
                    }));
                    sucursalModel.newSeries = newSeries;
                    this.RefreshSucursalModel(sucursalModel);
                });
                break;
            default:
                // return false
                break;
        }
    };

    toggleDocumentSelectedAll = (action, option) => {
        const { paymentMethods } = this.state;
        switch (option) {
            case 1:
                let newCheckbox = (new Map());
                for (let index = 0; index < paymentMethods.length; index++) {
                    newCheckbox.set(index, action);
                }
                this.setState({
                    checkboxPayMethods: newCheckbox
                });
                break;
            case 2:

                break;

            default:
                // return false;
                break;
        }


    };


    OpenSeriesModal = async (serie, value, docType = null) => {
        const { series, sucursalModel } = this.state
        let table = await this.selectTable(serie);
        let seriesNuevas = [];
        let selected = [];
        sucursalModel.newSeries = [];
        let nameProperty = this.NameProperty(serie);
        for (let index = 0; index < series.length; index++) {
            let element = series[index];
            element.selected = false;
            if (table.docType == 'SERIES') {
                if (element.Remark === 'SERIES' && element.ObjectCode === docType) {
                    seriesNuevas.push(element)
                }
            } else if (element.Remark !== 'SERIES' && element.ObjectCode === table.docType && element.DocSubType === table.docSubType && element.DocSubTypeNNM1 === table.docSubType && element.NextNumber <= element.LastNum) {
                seriesNuevas.push(element)
            }
        }
        if (value) {
            selected = value.split("|");
            for (let index = 0; index < selected.length; index++) {
                let idSerie = selected[index];
                const defSerie = idSerie?.split('~') ?? null
                idSerie = defSerie?.[0] ?? idSerie
                const defaultSerie = (defSerie?.[1] ?? '') == 'D' ?? false
                for (let index = 0; index < seriesNuevas.length; index++) {
                    let pos = seriesNuevas[index];
                    if (pos.Series === parseInt(idSerie) || String(pos.Series) === String(idSerie)) {
                        pos.selected = true;
                        pos.default = defaultSerie;

                    }
                }
            }
        } else {
            for (let index = 0; index < seriesNuevas.length; index++) {
                const pos = seriesNuevas[index];
                pos.selected = false;
            }
        }

        sucursalModel.newSeries = seriesNuevas;

        await this.setState({
            property: nameProperty.name,
            propertyCode: docType,
            showSeriesModal: !this.state.showSeriesModal,
        });
        this.RefreshSucursalModel(sucursalModel);
        $('#seriesModal').modal('show');
    };

    CloseSeriesModal = () => {
        const { sucursalModel } = this.state
        this.setState({
            showSeriesModal: !this.state.showSeriesModal,
            checkboxDocSeries: (new Map()),
        });
        sucursalModel.newSeries = [];
        this.RefreshSucursalModel(sucursalModel);
        $('#seriesModal').modal('hide');

    }

    SaveSeries = () => {
        const { property, sucursalModel, propertyCode } = this.state;
        let newSeries = sucursalModel.newSeries;
        let series = '';
        for (let index = 0; index < newSeries.length; index++) {
            const element = newSeries[index];
            if (element.selected) {
                series += `${element.Series}${element?.default ? '~D' : ''}|`;

            }
        }
        if (propertyCode) {
            sucursalModel[property] = sucursalModel[property] || {};
            sucursalModel[property][propertyCode] = series;

        } else {
            sucursalModel[property] = series;

        }
        this.RefreshSucursalModel(sucursalModel);
        this.CloseSeriesModal();
        $('#seriesModal').modal('hide');
    };

    //-----
    ShowRelatedPMBO = () => {
        $('#relationPMBABO').modal('show');
    }

    ShowAddPayMethod = async (boolValue) => {
        if (boolValue) {
            $('#relationPMBABO').modal('show');
        } else {
            $('#relationPMBABO').modal('hide');
        }
    }

    RefreshRelationModel = async (relationModel) => {
        await this.setState({ relationModel })
    }

    AddRelation = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { relationModel, accountsRelated } = this.state
        if (relationModel.idPMBO === '') {
            showAlert({ type: 'warning', message: "Aviso: Aun no has seleccionado un método de pago." })
            return;
        }
        if (relationModel.AcctCode === '') {
            showAlert({ type: 'warning', message: "Aviso: Aun no has seleccionado la cuenta de mayor que será afectada." })
            return;
        }
        let newArray = accountsRelated;
        newArray.push(relationModel)
        this.setState({
            accountsRelated: newArray,
            relationModel: new BankAccountRelationship(),
        })
    }

    DeleteAccountRelations = (index) => {
        const { accountsRelated } = this.state
        let newArray = accountsRelated;
        newArray.splice(index, 1); // 1 es la cantidad de elementos a eliminar
        this.setState({
            accountsRelated: newArray,
        })
    }


    AddRelationsToSucursal = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { sucursalModel, accountsRelated } = this.state
        if (accountsRelated.length === 0) {
            showAlert({ type: 'warning', message: "Aviso: No agregaste ninguna relación, la sucursal no fue afectada" })
            return
        }
        let newArray = sucursalModel.ListPayMethods;
        for (const account of accountsRelated) {
            newArray.push(account);
        }
        sucursalModel.ListPayMethods = newArray
        await this.RefreshSucursalModel(sucursalModel);
        this.ShowAddPayMethod(false);
        this.setState({
            accountsRelated: [],
            relationModel: new BankAccountRelationship(),
        })
    }

    DeletePayMethod = async (index) => {
        const { sucursalModel } = this.state;
        let newArray = sucursalModel.ListPayMethods;
        newArray.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        sucursalModel.ListPayMethods = newArray;
        this.RefreshSucursalModel(sucursalModel);
    }
    //-----
    AddPayMethod = async (boolValue) => {
        if (boolValue) {
            $('#newPayMethod').modal('show');
        } else {
            $('#newPayMethod').modal('hide');
        }
    }

    UpgradeDocumentLoopAlert = async (DocObject) => {
        $("#validationModal").modal("show");

        await this.setState({
            auxObjectUpgradeLoopDoc: DocObject
        })

    }


    SetInitialConsecutiveInfo = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props
        const { sucursalModalAction, sucursalModel, sucursalModelCopy } = this.state

        if (Number(sucursalModalAction) === 1 || !sucursalModelCopy.Code) {
            showAlert({ type: 'info', message: 'Los consecutivos están disponibles cuando una sucursal esta creada ' });
            return
        }

        enableSpinner(true);
        const responseApi = await apiClient.getConsecutiveDocsInfoByBO(sucursalModelCopy.Code);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return
        }

        if (responseApi.data.length === 0) {
            showAlert({ type: 'info', message: `No hay información de consecutivos de esta sucursal comunícate con FMB Solutions` });
            return
        }

        const documentsRequest = responseApi.data ? responseApi.data[0] : [];
        if (documentsRequest.length === 0) return
        let AuxArrayConsecutiveDocs = sucursalModel.ConsecutiveDocs.slice();

        for (let index = 0; index < AuxArrayConsecutiveDocs.length; index++) {
            let consecutiveDocElement = AuxArrayConsecutiveDocs[index];
            if (documentsRequest.hasOwnProperty(consecutiveDocElement.TypeDocId)) consecutiveDocElement.TypeDoc = Number(documentsRequest[consecutiveDocElement.TypeDocId]);
            if (documentsRequest.hasOwnProperty(consecutiveDocElement.TypeDocLoopId)) consecutiveDocElement.TypeDocLoop = Number(documentsRequest[consecutiveDocElement.TypeDocLoopId]);
        }
        sucursalModel.ConsecutiveDocs = AuxArrayConsecutiveDocs;
        await this.RefreshSucursalModel(sucursalModel);
        await this.setState({
            searchedConsecutiveInfo: true,
        })
    }

    SetInitialSeries = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props
        const { sucursalModalAction, sucursalModel, sucursalModelCopy } = this.state


        enableSpinner(true);
        const responseApi = await apiClient.listDocTypeSeries();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return
        }

        if (responseApi.data.length === 0) {
            showAlert({ type: 'info', message: `No hay información de series y correlativos de esta sucursal comunícate con FMB Solutions` });
            return
        }

        // const documentsRequest = responseApi.data ? responseApi.data[0] : [];
        // if (documentsRequest.length === 0) return
        // let AuxArrayConsecutiveDocs = sucursalModel.ConsecutiveDocs.slice();

        // for (let index = 0; index < AuxArrayConsecutiveDocs.length; index++) {
        //     let consecutiveDocElement = AuxArrayConsecutiveDocs[index];
        //     if (documentsRequest.hasOwnProperty(consecutiveDocElement.TypeDocId)) consecutiveDocElement.TypeDoc = Number(documentsRequest[consecutiveDocElement.TypeDocId]);
        //     if (documentsRequest.hasOwnProperty(consecutiveDocElement.TypeDocLoopId)) consecutiveDocElement.TypeDocLoop = Number(documentsRequest[consecutiveDocElement.TypeDocLoopId]);
        // }
        // sucursalModel.ConsecutiveDocs = AuxArrayConsecutiveDocs;
        // await this.RefreshSucursalModel(sucursalModel);
        await this.setState({
            documentTypeSeries: responseApi?.data ?? [],
        })
    }

    UpgradeDocumentLoop = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props
        const { auxObjectUpgradeLoopDoc, sucursalModelCopy } = this.state

        if (auxObjectUpgradeLoopDoc === null) {
            showAlert({ type: 'info', message: 'Algo salio mal al obtener información seleccionada, vuelva a presionar el botón de incrementar Loop ' });
            return
        }

        const data = {
            LoopId: auxObjectUpgradeLoopDoc.TypeDocLoopId,
            CodeBO: sucursalModelCopy.Code,
            TypeDocId: auxObjectUpgradeLoopDoc.TypeDocId,
        }

        enableSpinner(true);
        const responseApi = await apiClient.upgradeDocumentLoop(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return
        }
        showAlert({ type: 'success', message: responseApi.message });
        await this.SetInitialConsecutiveInfo();
    }

    render() {
        const {
            user,
            sucursales,
            sucursalModel,
            sucursalModalAction,
            showSearchSucursalModal,
            editModeSucursal,
            priceList,
            whsCode,
            partners,
            pageTotal,
            series,
            projects,
            paymentMethods,
            PayMethodModel,
            checkboxPayMethods,
            checkboxDocSeries,
            showSeriesModal,
            accounts,
            relationModel,
            accountsRelated,
            SAPCards,
            _user,
            searchedConsecutiveInfo,
            documentTypeSeries,
        } = this.state;

        let checkbox = {
            // data: checkboxPayMethods,
            data: checkboxDocSeries,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
            checkAll: this.selectAll
        }
        const modules = user.U_FMB_Modulos ? JSON.parse(user.U_FMB_Modulos) : null
        let writeAccess = false;
        if (modules.sucursales) {
            writeAccess = modules.sucursales.Wr
        }
        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={false} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'SUCURSALES'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="liSucursales" className="text-muted">
                            &nbsp;SUCURSALES
                        </a>
                    </h2>
                    <div>
                        <ValidationModal
                            idValidation="validationModal"
                            message="¿Esta seguro que quiere incrementar la vuelta del documento?"
                            eventOnclick={() => this.UpgradeDocumentLoop()} // aceptar 
                            eventOnclick2={() => { }}
                        />
                        <div>
                            <SucursalModal
                                user={user}
                                action={sucursalModalAction}
                                editMode={editModeSucursal}
                                sendModel={this.SendSucursalModel}
                                acceptEditMode={this.AcceptEditModeSucursal}
                                AcceptEdit={this.EditModeSucursal}
                                sucursalModel={sucursalModel}
                                refreshModel={this.RefreshSucursalModel}
                                SearchSucursal={this.SearchSucursal}
                                showSearchSucursalModal={showSearchSucursalModal}
                                OpenSearchSucursalModal={this.OpenSearchSucursalModal}
                                sucursales={sucursales}
                                CloseSearchSucursalModal={this.CloseSearchSucursalModal}
                                priceList={priceList}
                                whsCode={whsCode}
                                partners={partners}
                                pageTotal={pageTotal}
                                projects={projects}
                                OpenPartnerModal={this.OpenPartnerModal}
                                SelectPartner={this.SelectPartner}
                                RefreshPartner={this.RefreshPartner}
                                cleanData={() => this.setState({ partners: [] })}
                                DeletePartner={this.DeletePartner}
                                cancelEditMode={this.CancelEditModeSucursal}
                                series={series}

                                CleanInfo={this.CleanInfo}
                                ShowWhsModal={this.ShowWhsModal}
                                DeleteWhsLine={this.DeleteWhsLine}
                                PaymentMethods={paymentMethods}
                                PayMethodModel={PayMethodModel}
                                RefreshPayMethodModel={this.RefreshPayMethodModel}
                                ShowAddPayMethod={this.ShowAddPayMethod}
                                SendPayMethodModel={this.SendPayMethodModel}
                                checkbox={checkbox}

                                checkboxDocSeries={checkboxDocSeries}
                                OpenSeriesModal={this.OpenSeriesModal}
                                CloseSeriesModal={this.CloseSeriesModal}
                                showSeriesModal={showSeriesModal}
                                SaveSeries={this.SaveSeries}

                                ShowRelatedPMBO={this.ShowRelatedPMBO}
                                Accounts={accounts}
                                RefreshRelationModel={this.RefreshRelationModel}
                                AddRelation={this.AddRelation}
                                DeleteAccountRelations={this.DeleteAccountRelations}
                                AddRelationsToSucursal={this.AddRelationsToSucursal}
                                AccountsRelated={accountsRelated}
                                RelationModel={relationModel}
                                DeletePayMethod={this.DeletePayMethod}

                                AddPayMethod={this.AddPayMethod}
                                SAPCards={SAPCards}
                                writeAccess={writeAccess}
                                UpgradeDocumentLoop={this.UpgradeDocumentLoopAlert}
                                SetInitialConsecutiveInfo={this.SetInitialConsecutiveInfo}
                                SearchedConsecutiveInfo={searchedConsecutiveInfo}
                                SetInitialSeries={this.SetInitialSeries}
                                documentTypeSeries={documentTypeSeries}
                            />

                            <ListModal
                                IdModal={"generalListModal"}
                                HeaderTitle={'Almacenes disponibles'}
                                Body={this.bodyWhs()}
                                CloseActions={() => {
                                    this.CloseActionsWhs();
                                    this.ShowWhsModal(false);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    bodyWhs = () => {
        const { whsCode } = this.state

        const listWithIndex = (whsCode || [])
            .map((s, i) => ({ ...s, __origIndex: i }));

        const filtered = listWithIndex.filter(s =>
            s.WhsCode?.toLowerCase().includes(this.state.search.toLowerCase()) ||
            s.WhsName?.toLowerCase().includes(this.state.search.toLowerCase())
        );
        return (
            <div className="container">
                <div className="row justify-content-around">
                    <div className="col-12">
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Buscar serie..."
                            value={this.state.search}
                            onChange={(e) => this.setState({ search: e.target.value })}
                        />
                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                            <table className="table response" style={{ marginBottom: 0 }}>
                                <tr>

                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Código Almacén</td>
                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Nombre</td>
                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}></td>
                                </tr>
                                {!!filtered && filtered.map((whs, index) => {
                                    return (
                                        <tr key={whs.__origIndex ?? index}>
                                            <td className="text-center">{whs.WhsCode || ''}</td>
                                            <td className="text-center">{decodeText(whs.WhsName) || ''}</td>
                                            <td style={{ textAlign: "center" }}>
                                                <button type="button" className="btn btn-sm"
                                                    onClick={() => this.AddWhsLine(whs.__origIndex ?? index)}
                                                    style={{ fontWeight: '500', backgroundColor: "transparent", color: "#EABF28" }}>
                                                    <i className="fas fa-check"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    selectTable = (view = null, docTypeMiddleware = null) => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        switch (view) {
            case 'quotations':
                name = "OQUT";
                complement = "QUT1";
                docSubType = "--";
                docType = "23";
                break;
            case 'orderSales':
                name = "ORDR";
                complement = "RDR1";
                docSubType = "--";
                docType = "17";
                break;
            case 'deliveries':
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                break;
            case 'invoice':
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                break;
            case 'DownPayments':
                name = "ODPI";
                complement = "";
                docSubType = "--";
                docType = "203";
                break;
            case 'PurchaseDownPayments':
                name = "ODPO";
                complement = "";
                docSubType = "--";
                docType = "204";
                break;
            case 'return':
                name = "ORDN";
                complement = "RDN1";
                docSubType = "--";
                docType = "16";
                break;
            case 'purchaseReturn':
                name = "ORPD";
                complement = "RPD1";
                docSubType = "--";
                docType = "21";
                break;
            case 'payment':
                name = "ORCT";
                complement = "RCT1";
                docSubType = "--";
                docType = "24";
                break;
            case 'transfers':
                name = "OWTR";
                complement = "WTR1";
                docSubType = "--";
                docType = "67";
                break;
            case 'transfersRequest':
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case 'transfersEntry':
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            case 'transfersOutput':
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case 'debitNote':
                name = "OINVDN";
                complement = "INV1";
                docSubType = "DN";
                docType = "13";
                break;
            case 'creditNote':
                name = "ORIN";
                complement = "RIN1";
                docSubType = "--";
                docType = "14";
                break;
            case 'PurchaseOrder':
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case 'GoodsReceipt':
                name = "OPDN";
                complement = "PDN1";
                docSubType = "--";
                docType = "20";
                break;

            case 'PurchaseRequest':
                name = "OPRQ";
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;

            case 'invoiceBorrador':
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case 'invoiceAuthorization':
                name = "OWDD";
                complement = "OWDD";
                docSubType = "--";
                break;
            case 'bussinesPartner':
                name = "OCRD";
                complement = "CRD1";
                docSubType = "--";
                break;
            case 'inventoryRevaluation':
                name = "OMRV";
                complement = "MRV1";
                docSubType = "--";
                docType = "162";
                break;
            case 'SalesHelmets':
                name = "OIGN";
                name2 = "ORIN";
                complement = "IGN1";
                complement2 = "RIN1"
                docSubType = "--";
                docSubType2 = "--";
                docType = "59";
                docType2 = "14"
                break;
            case 'ExitHelmets':
                name = "OIGE";
                name2 = "OINVDN";
                complement = "IGE1";
                complement2 = "INV1"
                docSubType = "--";
                docSubType2 = "DN";
                docType = "60";
                docType2 = "13"
                break;
            case 'purchaseQuotation':
                name = "OPQT";
                complement = "PQT1";
                docSubType = "--";
                docType = "540000006";
                break;
            case 'purchaseInvoice':
                name = "OPCH";
                complement = "PCH1";
                docSubType = "--";
                docType = "18";
                break;
            case 'purchaseCreditNotes':
                name = "ORPC";
                complement = "RPC1";
                docSubType = "--";
                docType = "19";
                break;
            case 'purchaseDebitNotes':
                name = "OPCH";
                complement = "PCH1";
                docSubType = "DM";
                docType = "18";
                break;
            case 'outgoingPayment':
                name = "OVPM";
                complement = "VPM1";
                docSubType = "--";
                docType = "46";
                break;
            case 'invoiceReserve':
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                break;
            case 'middleware':
                if (docTypeMiddleware === '22') {
                    name = "OPOR";
                    complement = "POR1";
                    docSubType = "--";
                    docType = "22";
                } else if (docTypeMiddleware === '18') {
                    name = "OPCH";
                    complement = "PCH1";
                    docSubType = "--";
                    docType = "18";
                }

                break;
            case 'LandedCosts':
                name = "OIPF";
                complement = "IPF2";
                docSubType = "--";
                docType = "69";
                break;
            case 'ProductionOrder':
                name = "OWOR";
                complement = "WOR1";
                docSubType = "--";
                docType = "202";
                break;

            case 'InventoryGenExits':
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;

            case 'InventoryGenEntries':
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;

            case 'Sugerido':
                name = "SRFM";
                complement = "RFM1";
                docSubType = "--";
                docType = "117";
                break;
            case 'InventoryCounting':
                name = "OINC";
                complement = "INC1";
                docSubType = "--";
                docType = "1470000065";
                break;
            case 'InventoryPosting':
                name = "OIQR";
                complement = "IQR1";
                docSubType = "--";
                docType = "10000071";
                break;
            case 'PurchaseQuotation':
                name = "OPQT";
                complement = "PQT1";
                docSubType = "--";
                docType = "540000006";
                break;
            case 'SERIES':
            case 'SERIESPUERTA':
                name = "SERIES";
                complement = "SERIES";
                docSubType = "--";
                docType = "SERIES";
                break;

            default:
                name = "";
                complement = "";
                docSubType = "";
                docType = "13";
        }

        return { name, complement, docSubType, docType, name2, complement2, docSubType2, docType2 }
    };

    NameProperty = (property = null) => {
        let name = "";
        switch (property) {
            case 'invoice':
                name = "U_FMB_ValidateSeriesOINV";
                break;
            case 'DownPayments':
                name = "U_FMB_ValidateSeriesODPI";
                break;
            case 'PurchaseDownPayments':
                name = "U_FMB_ValidateSeriesODPO";
                break;
            case 'quotations':
                name = "U_FMB_ValidateSeriesOQUT";
                break;
            case 'orderSales':
                name = "U_FMB_ValidateSeriesORDR";
                break;
            case 'deliveries':
                name = "U_FMB_ValidateSeriesODLN";
                break;
            case 'return':
                name = "U_FMB_ValidateSeriesORDN";
                break;
            case 'payment':
                name = "U_FMB_ValidateSeriesORCT";
                break;
            case 'transfers':
                name = "U_FMB_ValidateSeriesOWTR";
                break;
            case 'debitNote':
                name = "U_FMB_ValidateSeriesDN";
                break;
            case 'creditNote':
                name = "U_FMB_ValidateSeriesORIN";
                break;
            case 'transfersRequest':
                name = "U_FMB_ValidateSeriesOWTQ";
                break;
            case 'transfersEntry':
                name = "U_FMB_ValidateSeriesOIGN";
                break;
            case 'transfersOutput':
                name = "U_FMB_ValidateSeriesOIGE";
                break;
            case 'PurchaseOrder':
                name = "U_FMB_ValidateSeriesOPOR";
                break;
            case 'PurchaseRequest':
                name = "U_FMB_ValidateSeriesOPRQ";
                break;
            case 'purchaseReturn':
                name = "U_FMB_ValidateSeriesORPD";
                break;
            case 'inventoryRevaluation':
                name = "U_FMB_ValidateSeriesOMRV";
                break;
            case 'GoodsReceipt':
                name = "U_FMB_ValidateSeriesOPDN";
                break;
            case 'outgoingPayment':
                name = "U_FMB_ValidateSeriesOVPM";
                break;
            case 'purchaseQuotation':
                name = "U_FMB_ValidateSeriesOPQT";
                break;
            case 'purchaseInvoice':
                name = "U_FMB_ValidateSeriesOPCH";
                break;
            case 'purchaseCreditNotes':
                name = "U_FMB_ValidateSeriesORPC";
                break;
            case 'purchaseDebitNotes':
                name = "U_FMB_ValidateSeriesDM";
                break;
            case 'LandedCosts':
                name = "U_FMB_ValidateSeriesOIPF";
                break;
            case 'ProductionOrder':
                name = "U_FMB_ValidateSeriesOWOR";
                break;
            case 'InventoryGenExits':
                name = "U_FMB_SeriesInventoryGenExits";
                break;
            case 'InventoryGenEntries':
                name = "U_FMB_SeriesInventoryGenEntries";
                break;
            case 'Sugerido':
                name = "U_FMB_SeriesSugerido";
                break;
            case 'InventoryCounting':
                name = "U_FMB_ValidateSeriesOINC";
                break;
            case 'InventoryPosting':
                name = "U_FMB_ValidateSeriesOIQR";
                break;
            case 'PurchaseQuotation':
                name = "U_FMB_ValidateSeriesOPQT";
                break;
            case 'SERIES':
                name = "U_FMB_ValidateSeriesSUNAT";
                break;
            case 'SERIESPUERTA':
                name = "U_FMB_ValidateSeriesPUERTA";
                break;
            default:
                name = "";
        }

        return { name }
    };
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};



export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SucursalView);
